import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-round-info',
  templateUrl: './round-info.component.html',
  styleUrls: ['./round-info.component.css']
})
export class RoundInfoComponent implements OnInit {
  @Input() imageUrl: string;
  @Input() infoTitle: string;
  @Input() infoDescription: string;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/home/intro-section/round-info/round-info.component.ts